import { isNullOrUndefined } from 'util';
import { HttpErrorResponse } from "@angular/common/http";
import { Injectable, Component, Inject } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { MatSnackBar, MAT_SNACK_BAR_DATA } from "@angular/material/snack-bar";
import { ErrorMessage } from "src/dto/errorClass/error";
import { environment } from "src/environments/environment";
import { AnonymousService } from "src/services/anonymous-service";
import { ErrorModalComponent } from "src/shared/error-modal/error-modal.component";
import { RegisterDialog } from "../register/register.dialog";
import { UtilsFunctions } from 'src/shared/functions/utils-functions';

@Component({
    selector: 'authentification-dialog',
    templateUrl: './authentification.dialog.html',
    styleUrls: ['./authentification.dialog.scss']
})


@Injectable()
export class AuthentificationDialog {
    isLoading = false;
    hide = "password";

    email: string;
    password: string;
    currentUser: any;

    emailFormControl = new FormControl('', [Validators.required]);
    passwordFormControl = new FormControl('', [Validators.required]);

    constructor(private _snackBar: MatSnackBar, public dialog: MatDialogRef<AuthentificationDialog>,
        private anonymousSvc: AnonymousService,public dialogr: MatDialog) {
    }

    ngOnInit() {
        this.currentUser = UtilsFunctions.SessionGetCurrentUser();
    }

    async connexion() {
        if(!this.checkForm()){
            this._snackBar.openFromComponent(ErrorModalComponent, {
                duration: environment.errorDuration,
                data: new ErrorMessage(-1, "Merci de remplir tous les champs")
            });
            return;
        }

        this.isLoading = true;
        try {
            var rslt = await this.anonymousSvc.connexion(this.email, this.password)
            this._snackBar.openFromComponent(ErrorModalComponent, {
                duration: environment.errorDuration,
                data: new ErrorMessage(1, "Connexion établie")
            });
            this.dialog.close(rslt);
        }
        catch(ex){
            this._snackBar.openFromComponent(ErrorModalComponent, {
                duration: environment.errorDuration,
                data: new ErrorMessage(-1, ex.error.code)
            });
        }
        this.isLoading = false;
    }

    forgetPassword(){
        this.dialog.close("FORGET_PASSWORD");
    }

    checkForm(){
        if(!this.emailFormControl.valid || !this.passwordFormControl.valid)
            return false;
        return true;
    }

    register(): void{
        const dialogCard = this.dialogr.open(RegisterDialog, {
            width: '80%',
            height: '90%',
            panelClass: 'mat-dialog-any-padding',
            autoFocus: false
        });

        dialogCard.afterClosed().subscribe(rslt => {
            if (!isNullOrUndefined(rslt))
                this.currentUser = UtilsFunctions.SessionGetCurrentUser();
        });
    }
}